import React from "react";

import { Dialog } from "@mui/material";

import Assessments from "../../../pages/Assessments/Assessments";


const SelectAssesmentAndCriteriaModal = ({ open, onClose, onSelect }) => {
  return (
    <Dialog
      onClose={onClose}
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          margin: 0,
          p: 0,
          overflow: { xs: "auto", lg: "hidden" },
          maxWidth: "none",
          height: "99vh",
          borderRadius: "15px",
          width: { xs: "98vw", lg: "82vw" },
        },
      }}
    >
      <Assessments isModal onClose={onClose} onSelect={onSelect} />
    </Dialog>
  );
};

export default SelectAssesmentAndCriteriaModal;